var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modelHeadingWrapper"},[_c('div',{staticClass:"underModelHeadingWrapper"},[_c('p',[_vm._v("modell:")]),_c('h1',[_vm._v(_vm._s(_vm.selectedBrand))])])])}
var staticRenderFns = []

export { render, staticRenderFns }